module.exports = __webpack_public_path__ + "cf2445dcb53a031c02f9b57e2199bc03.ico";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/misc/favicon - Copy.ico
// module id = 198
// module chunks = 0